import { isReadOnlyUser } from './access';
import { canAccessProfesionalFeatures } from './profesionalAccess';

/** Vista contador: Profesional+ o usuario Lector invitado como contador. */
export function canAccessVistaContador(user) {
  if (!user) return false;
  if (user.isSuperAdmin === true || user.role === 'admin') return true;
  if (isReadOnlyUser(user)) return true;
  return canAccessProfesionalFeatures(user);
}
